import Vue from 'vue'
import Router from 'vue-router'
import BootstrapVue from 'bootstrap-vue'
import LoginPage from '@/pages/LoginPage'
import NotFoundPage from '@/pages/NotFoundPage'
import KeycloakPage from '@/pages/KeycloakPage'
import UserRoutes from './user-routes'
import OrganizationRoutes from './org-routes'
import RecordingRoutes from './recording-routes'
import EmeGroupRoutes from './emegroup-routes'
import TeamsRoutes from './teams-routes'
import changeTargetNumberRoutes from './change-target-number-routes'
import ContactsRoutes from './contacts-routes'
import ConGroupRoutes from './congroup-routes'
import ReserveRoutes from './reserve-routes'
import OperationRoutes from './operation-routes'
import MessagesRoutes from './messages-routes'
import CallsRoutes from './calls-routes'
import FolderRoutes from './folder-routes'
import PhotoGroupRoutes from './photogroup-routes'
import HospitalRoutes from './hospital-routers'
import AudioRoutes from './audio-routes'
import AnnounceRoutes from './announse-routes'
import DeviceRoutes from './device-routes'
import SettingRoutes from './setting-routes'
import KeycloakRoutes from './keycloak-routes'
import RoleRoutes from './role-routes'
import IconRoutes from './icon-routes'
import FunctionRoutes from './function-routes'
import StandardPhoneRoutes from './standardphone-routes'
import PasswordPolicyRoutes from './password-policy-routes'

const Settings = () => import('@/components/Settings')
const CommonPage = () => import('@/pages/CommonPage')
const ContactsAppPage = () => import('@/pages/ContactsAppPage')
const EmergencyAppPage = () => import('@/pages/EmergencyAppPage')
const LogPage = () => import('@/pages/LogPage')
const PhotoPage = () => import('@/pages/PhotoPage')
const ConferenceAppPage = () => import('@/pages/ConferenceAppPage')

Vue.use(Router)
Vue.use(BootstrapVue)

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

var authType = process.env.VUE_APP_AUTH_TYPE || 'Cognito'
var serviceName = process.env.VUE_APP_SERVICE_NAME || 'Nichibyo'

var mode = 'hash'
if (authType === 'Keycloak') {mode = 'history'}
var title = 'メドコム 管理サイト'
if (serviceName === 'SmartPhone') {title = 'スマートフォン内線サービス'}

const router =  new Router({
  mode: mode, // history or hash
  routes: [
    {
      path: '/login',
      name: 'login',
      component: LoginPage,
      props: () => ({serviceName: serviceName}),
    },
    {
      path: '/:realms/login',
      component: LoginPage,
      props: true
    },
    {
      path: '/:realms/keycloak',
      component: KeycloakPage,
      props: true
    },
    {
      path: '/',
      component: Settings,
      props: () => ({serviceName: serviceName}),
      beforeEnter: (to, from, next) => {
        if (authType === 'Keycloak') next({name: 'notFoundPage'})
        else next()
      },
      children: [
        {
          path: 'common',
          component: CommonPage,
          children: [
            UserRoutes,
            OrganizationRoutes,
            ReserveRoutes,
            HospitalRoutes,
            AnnounceRoutes,
            RoleRoutes,
            SettingRoutes,
            changeTargetNumberRoutes,
            FunctionRoutes,
            IconRoutes
          ],
          props: () => ({serviceName: serviceName}),
        },
        {
          path: 'contacts',
          component: ContactsAppPage,
          children: [
            TeamsRoutes,
            ContactsRoutes,
            ConGroupRoutes,
            StandardPhoneRoutes
          ]
        },
        {
          path: 'emergency',
          component: EmergencyAppPage,
          children: [
            RecordingRoutes,
            EmeGroupRoutes
          ]
        },
        {
          path: 'log',
          component: LogPage,
          children: [
            OperationRoutes,
            MessagesRoutes,
            CallsRoutes,
            DeviceRoutes
          ],
          props: () => ({serviceName: serviceName}),
        },
        {
          path: 'photo',
          component: PhotoPage,
          children: [
            FolderRoutes,
            PhotoGroupRoutes
          ]
        },
        {
          path: 'conference',
          component: ConferenceAppPage,
          children: [
            AudioRoutes
          ]
        }
      ]
    },
    {
      path: '/:realms/',
      component: Settings,
      beforeEnter: (to, from, next) => {
        if (authType === 'Cognito') next({name: 'notFoundPage'})
        else next()
      },
      props: true,
      children: [
        {
          path: 'common',
          component: CommonPage,
          children: [
            UserRoutes,
            OrganizationRoutes,
            ReserveRoutes,
            HospitalRoutes,
            AnnounceRoutes,
            SettingRoutes,
            changeTargetNumberRoutes,
            RoleRoutes,
            FunctionRoutes,
            KeycloakRoutes,
            PasswordPolicyRoutes,
            IconRoutes
          ]
        },
        {
          path: 'contacts',
          component: ContactsAppPage,
          children: [
            TeamsRoutes,
            ContactsRoutes,
            ConGroupRoutes,
            StandardPhoneRoutes
          ]
        },
        {
          path: 'emergency',
          component: EmergencyAppPage,
          children: [
            RecordingRoutes,
            EmeGroupRoutes
          ]
        },
        {
          path: 'log',
          component: LogPage,
          children: [
            OperationRoutes,
            MessagesRoutes,
            CallsRoutes,
            DeviceRoutes
          ]
        },
        {
          path: 'photo',
          component: PhotoPage,
          children: [
            FolderRoutes,
            PhotoGroupRoutes
          ]
        },
        {
          path: 'conference',
          component: ConferenceAppPage,
          children: [
            AudioRoutes
          ]
        }
      ]
    },
    {
      path: '/*',
      name: 'notFoundPage',
      component: NotFoundPage
    }
  ]
})

router.afterEach(() => {
  document.title = title
})

export default router
